/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { KeycloakClient } from 'core/services/keycloak/keycloak.client';
import { from, Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class IncludeBearerTokenInterceptor implements HttpInterceptor {
  private readonly keycloakClient = inject(KeycloakClient);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.url.includes('api/v1/')) {
      return from(this.keycloakClient.getKeycloakInstance().updateToken(30)) // Update token if it expires in less than 30 seconds
        .pipe(
          switchMap(() => {
            const accessToken = this.keycloakClient.getAccessToken();
            const requestWithBearerToken = request.clone({
              setHeaders: {
                Authorization: `Bearer ${accessToken}`,
              },
            });
            return next.handle(requestWithBearerToken);
          }),
          catchError((error: HttpErrorResponse) => {
            if (error.status === HttpStatusCode.Unauthorized) {
              this.keycloakClient.login().then();
            }
            return throwError(() => error);
          }),
        );
    }
    return next.handle(request);
  }
}
